import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const PLAN_CHANGE_PATH = '/plan-change'

/**
 * The one way into a plan change from anywhere in the app, so the in-app flow's
 * acknowledgment, committed-term timing and audit row cannot be bypassed by whichever entry
 * point a customer happens to click.
 */
export const usePlanChangeEntry = () => {
  const navigate = useNavigate()

  const goToPlanChange = useCallback(() => {
    navigate(PLAN_CHANGE_PATH)
  }, [navigate])

  return { goToPlanChange }
}
